import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Home } from 'lucide-react';
import '../styles/global.css';

export function NotFound() {
  return (
    <div className="app">
      <Header />
      <main className="not-found">
        <div className="content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <Link to="/" className="btn btn-primary">
            <Home size={18} /> Back to Home
          </Link>
        </div>
      </main>
      <Footer />
      <style>{`
        .not-found {
          padding: 150px 20px 100px;
          text-align: center;
          min-height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .content h1 {
          font-size: 8rem;
          margin-bottom: 0;
          background: linear-gradient(135deg, #0070f3 0%, #fff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          line-height: 1;
        }
        .content h2 {
          font-size: 2rem;
          margin-bottom: 1.5rem;
          color: #fff;
        }
        .content p {
          color: #888;
          margin-bottom: 3rem;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
        }
      `}</style>
    </div>
  );
}
